import NiceModal from "@ebay/nice-modal-react";

import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./Modal.module.css";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import qrIcon from "resources/dummy/qrcode222.png";
import liquidIcom from "resources/dummy/소다 1.png";
import closeIcon from "resources/dummy/Group 62.png";
import Inline from "layouts/container/Inline";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { QRCodeSVG } from "qrcode.react";
import favicon from "resources/img/favicon.ico";
// import { HOST } from "routes/front/main/WebSocketContainer";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "components/buttons/CustomButton";

import { requester } from "App";
import { toast } from "react-toastify";
import { CollectionsBookmark } from "@mui/icons-material";
import { AuthContext } from "providers/AuthProvider";
import ProcessBar from "routes/front/main/vending/mainPage/ProcessBar";
import { decode } from "shared/utils/Utils";
// import paymentSound from "resources/music/paymentSound.mp3";

const TestPaymentModal = NiceModal.create(props => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [false, false];
  const [width, height] = ["80%", "65%"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const title = t("");
  const buttonText = t("close");
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.products);
  const [cartList, setCartList] = useState([]);
  const [total, setTotal] = useState(0);
  const [timer, setTimer] = useState(60 * 3); // 3분 타이머
  const [paymentResult, setPaymentResult] = useState();
  const [machineData, setMachineData] = useState();
  const countdownInterval = useRef(null);
  const showTimer = timer <= 60;
  const { id } = useParams();
  // 원의 둘레 계산
  const radius = 20; // 원의 반지름
  const circumference = 2 * Math.PI * radius;
  // 시간이 감소함에 따라 strokeDashoffset을 감소시켜 원이 점점 비워지는 효과
  // strokeDashoffset을 계산하여 원이 점점 줄어드는 효과를 만듭니다.
  // 타이머가 줄어들 때 원의 둘레에 비례하여 strokeDashoffset 값이 감소합니다.
  const strokeDashoffset = showTimer ? (1 - timer / 60) * circumference : circumference;
  const navigate = useNavigate();
  // const audioRef = useRef();

  useEffect(() => {
    window.addEventListener("showWaitingModal", () => {
      NiceModal.show("addressKr")
    });
    window.addEventListener("closeWaitingModal", () => {
      NiceModal.show("addressKr")
    });

    return () => {
      window.removeEventListener("showWaitingModal", () => { });
      window.removeEventListener("closeWaitingModal", () => { });
      // audioRef.current.play();
    };
  }, []);

  useEffect(() => {
    if (timer > 60) return; // 60초 이상이면 타이머 작동하지 않음

    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
      if (timer === 0) {
        clearInterval(interval);
        modal.current.close(); // 모달 닫기
        navigate(`/ws/${props.id}/home`); // 홈으로 이동
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timer, modal, navigate, props.id]);

  // 타이머 시각적 표현
  // 타이머가 60초 미만일 때만 표시




  const PaymentQR = () => {
    
    const extractedData = cartList.map(item => ({
      locationNo: item.locationNo,
      quantity: item.quantity,
      deviceId: item.deviceId
    }));
    
    // const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);
    const extractedValues = extractedData.map(item => {
      const deviceIdSuffix = item.deviceId ? item.deviceId.slice(-3) : '';
      return [item.locationNo, item.quantity, deviceIdSuffix];
  });
    

    const trxId = paymentResult && paymentResult.link.trxId;
    const trackId = paymentResult && paymentResult.link.trackId; //purchaseorder Id
    const amount = paymentResult && paymentResult.link.amount; // amount 
    const storeCode = paymentResult && paymentResult.link.udf1;
    const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";






    // const processedCartData = cartData.map(product => {
    //   const filteredProduct = {};

    //   Object.entries(product).forEach(([key, value]) => {
    //     if (!key.endsWith('Img') && value !== null) {
    //       filteredProduct[key] = value;
    //     }
    //   });

    //   return filteredProduct;
    // });
    

    const jsonData = extractedValues;

    const jsonString = JSON.stringify(jsonData);
    const base64EncodedString = btoa(jsonString);
    const param = `data=${base64EncodedString}`;

    return (
      <QRCodeSVG

        value={`${props.id}/testRecive?${param}&purchaseOrderId=${trackId}&amount=${amount}&storeCode=${storeCode}&deviceCode=${deviceCode}`}

        size={"20vw"}
        bgColor={"#ffffff"}
        // bgColor={"#fe5b35"}
        fgColor={"#000000"}
        level={"L"}
        includeMargin={false}
      // imageSettings={{
      //   src: favicon,
      //   x: undefined,
      //   y: undefined,
      //   height: 48,
      //   width: 48,
      //   excavate: true,
      // }}
      />
    );
  }

  const SignUpQR = () => {
    return (
      <QRCodeSVG
        // value={`${window.location.origin}/ws/${props.id}/signUp`}
        value={`${window.location.origin}/appRedirect`}
        // value={"puffu://MainScreen"}
        size={"20vw"}
        bgColor={"#ffffff"}
        // bgColor={"#fe5b35"}
        fgColor={"#000000"}
        level={"L"}
        includeMargin={false}
      // imageSettings={{
      //   src: favicon,
      //   x: undefined,
      //   y: undefined,
      //   height: 48,
      //   width: 48,
      //   excavate: true,
      // }}
      />
    );
  }



  useEffect(() => {

    setCartList(cartData);
    if (cartData.length === 0) {
      props.onClose();
      modal.current.close();
    }
  }, [cartData])

  useEffect(() => {

    if (cartList && cartList.length > 0) {
      const totalPrice = cartList.reduce((total, item) => {
        return total + (item.quantity * item.price);
      }, 0);
      setTotal(totalPrice);
      TestOnClick();
    }

  }, [cartList]);
  

  const TestOnClick = () => {
    const newTotal = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
    const extractedData = cartList.map(item => ({
      locationNo: item.locationNo,
      quantity: item.quantity,

    }));
    const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);
    const jsonMachineData = extractedValues;
    // const jsonData = { id: props.id, total: total };
    const jsonMachineString = JSON.stringify(jsonMachineData);
    const base64EncodedString = btoa(jsonMachineString);

    let data = {
      orderProducts: cartData,
      amount: newTotal,
      userName: props.userName,
      storeCode: props.id,
      machineData: base64EncodedString,
      returnUrl: 'http://118.42.47.43:3000/ws/5/homepage'
    };
    const jsonString = JSON.stringify(data);
    



    
    // requester.purchaseOrder를 프로미스로 감싸기
    if (cartData && cartData.length > 0) {
      // if(window.BRIDGE && window.BRIDGE.processPaymentRequest){
    
      //   window.BRIDGE.processPaymentRequest(jsonString);
      // }
    
      requester.testPaymentRequest(data, (result) => {
    
        let ready = result.data;
    
        if (result.code === 0) {
          const jsonString = JSON.stringify(result.data);
    

          let ready = result.data;
          requester.testPayment(ready, (result) => {
    
            if (result.code === 0) {
              // navigate("/payment", { state: { data: result.data } })
              setPaymentResult(result.data);
    
              const jsonString = JSON.stringify(result.data);
    
              if (window.BRIDGE && window.BRIDGE.sendPaymentResult) {
                window.BRIDGE.sendPaymentResult(jsonString);
              }
    
            }
          })

        } else {
          toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
            autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
          });
        }
      })
      // navigate(`/ws/${props.id}/payment/gateway2?type=product&orderId=${result.data.id}&amount=${result.data.amount}&storeCode=${props.id}`);
    } else {
      toast.error("장바구니에 물건이 없습니다.", {
        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
      });
    }

    // const paymentData = {
    //     amount: newTotal,
    //     orderId: resultData && resultData.id,
    //     orderName: resultData.orderProducts[0] && resultData.orderProducts[0].productName + '외 ' + (resultData.orderProducts.length - 1),
    //     customerName: '홍길동',
    //     successUrl: `http://puffu.co.kr/ws/root/payment/gateway?type=product`,
    //     failUrl: "http://puffu.co.kr/ws/root/main",
    // };
    // tossPayments.requestPayment('CARD', paymentData);
  }

  const Product = (props) => {
    const { data } = props;
    const deleteCartProductClick = () => {
      dispatch(CartReducer.actions.removeProductFromCart(data));
    }
    return (
      <VerticalFlex>
        <FlexChild width={"95%"} padding={"10px 0"}>
          <HorizontalFlex gap={10}>
            <FlexChild width={"20%"}>
              <img src={data.productImg} width={"100%"} />
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10}>
                <FlexChild>
                  <Center width={"100%"} textAlign={"left"}>
                    <P size={"2vw"} >
                      {data.productName} X {data.quantity}
                    </P>
                  </Center>
                </FlexChild>
                <FlexChild>
                  <Center width={"100%"} textAlign={"left"}>
                    <P size={"2vw"} weight={"bold"} font={"gmarketSansBold"}>
                      {(data.price * data.quantity).toLocaleString()}원
                    </P>
                  </Center>
                </FlexChild>
              </HorizontalFlex>

            </FlexChild>
            <FlexChild justifyContent={"flex-end"} width={40}>
              <img src={closeIcon} style={{ width: "100%" }} onClick={deleteCartProductClick} />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        {
          props.line
            ?
            null
            :
            <FlexChild>
              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#757575",
                }}
              />
            </FlexChild>
        }

      </VerticalFlex>

    );
  }



  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
      overflow={"visible"}
      // borderRadius={"25px"}
      onClose={props.onClose}
    >
      {/* <audio ref={audioRef} src={paymentSound} preload="auto" /> */}
      {/* <div style={{padding: "5vw"}}> */}
      <VerticalFlex padding={"4vw"} gap={10}>
        <FlexChild>
          <ProcessBar modal payment />
          <div style={{ width: "100%", height: "2px", backgroundColor: "black" }} />
        </FlexChild>
        {/* <FlexChild alignItems={"flex-start"}>
          <div style={{ position: 'relative', width: '80px', height: '80px' }}>
            {showTimer && (
              <div style={{ position: 'relative', width: '80px', height: '80px' }}>
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 50 50"
                >
                  <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke="#EC4715"
                    strokeWidth="5"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    transform="rotate(-90 25 25)"
                    style={{ transition: 'stroke-dashoffset 1s linear' }}
                  />
                </svg>
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    color: '#EC4715',
                    fontWeight: 'bold',
                    fontSize: "20px",
                    fontFamily: "gmarketSansBold"

                  }}
                >
                  {timer}
                </div>
              </div>
            )}
          </div>
        </FlexChild> */}
        {/* <FlexChild>
          <CustomButton text={"결제하기"} onClick={TestOnClick} />
        </FlexChild> */}
        <FlexChild>
          <HorizontalFlex>
            <FlexChild>
              <Center width={"100%"} textAlign={"left"}>
                <P color={"#FE531F"} weight={"bold"} size={40}>
                  총 {cartList.length}개 상품
                </P>
                <P color={"black"} weight={"bold"} size={25}>
                  {total.toLocaleString()}원
                </P>
                <P color={"#757575"} size={20}>
                  QR을 찍어 앱으로 결제하세요
                </P>
              </Center>
            </FlexChild>
            <FlexChild width={"max-content"}>
              <PaymentQR />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>

        <FlexChild height={"30px"}></FlexChild>
        <FlexChild>
          <VerticalFlex gap={10} flexStart>
            <FlexChild height={"max-content"}>
              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#757575",
                }}
              />
            </FlexChild>
            <div style={{ height: "max-content" }}>
              <div style={{ overflow: "hidden", height: "350px", display: "flex", flexDirection: "column", overflowY: "scroll" }}>
                {
                  cartList.map((data, index) => {
                    const isLastElement = index === cartList.length - 1;
                    return <Product data={data} {...(isLastElement && { line: true })} />;
                  })
                }
              </div>
            </div>
            <FlexChild height={"max-content"}>
              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#757575",
                }}
              />
            </FlexChild>
          </VerticalFlex>
        </FlexChild>
        {/* <FlexChild height={"40px"}></FlexChild> */}
        <FlexChild>
          <HorizontalFlex padding={"20px"}>
            <FlexChild>
              <Center width={"100%"} textAlign={"left"}>
                <P size={"2vw"}>잠깐! 결제가 안되나요?</P>
                <Inline>
                  <P size={"2vw"}>결제하려면 </P>
                  <P color={"#FE531F"} size={"2vw"}>
                    회원가입
                  </P>
                  <P size={15}>이 필요해요</P>
                </Inline>
              </Center>
            </FlexChild>
            <FlexChild justifyContent={"flex-end"}>
              <SignUpQR />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
      {/* </div> */}
    </ModalBase>
  );
});

export default TestPaymentModal;
